import {FormField} from "../types/enums";

export const organizationFormSectionData = {
  title: "Organizace",
  basicData: [
    {
      label: "Název organizace",
      inputType: "text",
      name: "organizationName",
    },
    {
      label: "Adresa organizace",
      inputType: "text",
      name: "address",
      requiredErrorMessage: "Adresa je povinná.",
    },
    {
      label: "Jméno vedoucího skupiny",
      inputType: "text",
      name: "leaderName",
      requiredErrorMessage: "Jméno vedoucího je povinné.",
      validationPatternValue: /^.{2,}$/,
      errorMessage: "Jméno musí obsahovat alespoň dva znaky.",
    },
    {
      label: "Příjmení vedoucího skupiny",
      inputType: "text",
      name: "leaderLastName",
      requiredErrorMessage: "Příjmení vedoucího je povinné.",
      validationPatternValue: /^.{2,}$/,
      errorMessage: "Příjmení musí obsahovat alespoň dva znaky.",
    },
    {
      label: "E-mail vedoucího skupiny",
      inputType: "email",
      name: "email",
      requiredErrorMessage: "E-mail je povinný.",
      validationPatternValue: /^\S+@\S+$/i,
      errorMessage: "Vyplňte platný e-mail.",
    },
    {
      label: "Telefonní číslo vedoucího skupiny",
      inputType: "text",
      name: "phoneNumber",
      requiredErrorMessage: "Telefonní číslo je povinné.",
      validationPatternValue:
        /^\+?\d{1,4}[\s.-]?\(?\d{1,4}\)?[\s.-]?\d{1,4}[\s.-]?\d{1,9}$/,
      errorMessage: "Vyplňte platné telefonní číslo.",
    },
  ],
  accommodationsData: [
    {
      label: "Název ubytování",
      inputType: "text",
      name: FormField.NameOfAccommodation,
      id: "customAccommodationName",
      requiredErrorMessage: "Název ubytování je povinný.",
      descriptionMessage:
        "Uveďte název zařízení, které jste si individuálně zajistili.",
    },
    {
      label: "Místo ubytování",
      inputType: "text",
      requiredErrorMessage: "Místo ubytování je povinné.",
      name: FormField.PlaceOfAccommodation,
      id: "customAccommodationAddress",
      descriptionMessage:
        "Uveďte místo zařízení, které jste si individuálně zajistili.",
    },
  ],
  accommodationTypeData: {
    label: "Typ ubytování",
    inputType: "select",
    name: FormField.AccommodationType,
    requiredErrorMessage: "Typ ubytování je povinný.",
    id: "accommodationType",
    placeholder: "Nejprve zvolte typ ubytování",
  },
};
